
<template>
    <div class="doctorList">
        <div class="outer-border margin-bottom-three">
            <el-row class="title-border-bottom">
                <div class="b-title fl">医师列表</div>
            </el-row>
            <div class="outer-row">
                <el-row class="margin20">
                    <el-col>
                        <div class="search">
                            <div class="search-inp">
                                <div class="item">
                                    医师姓名:
                                    <el-input
                                        size="small"
                                        v-model.trim="searchObj.realName"
                                        @blur="getList(1)"
                                    ></el-input>
                                </div>
                                <div class="item">
                                    医院名称:
                                    <el-input
                                        size="small"
                                        v-model.trim="searchObj.hospital"
                                        @blur="getList(1)"
                                    ></el-input>
                                </div>
                                <div class="item">
                                    医师职称:
                                    <el-select
                                        size="small"
                                        v-model="searchObj.title"
                                        filterable
                                        clearable
                                        placeholder="请选择"
                                        @change="getList(1)"
                                    >
                                        <el-option
                                            v-for="item of zcList"
                                            :key="item.lableTwo"
                                            :value="item.lableTwo"
                                            :label="item.lableTwo"
                                        ></el-option>
                                    </el-select>
                                </div>
                                <div class="item">
                                    擅长领域:
                                    <el-select
                                        size="small"
                                        v-model="searchObj.adeptDepartment"
                                        filterable
                                        clearable
                                        placeholder="请选择"
                                        @change="getList(1)"
                                    >
                                        <el-option
                                            v-for="item of sclyList"
                                            :key="item.lableTwo"
                                            :value="item.lableTwo"
                                            :label="item.lableTwo"
                                        ></el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="doctor-outer-div">
                <div class="border-ddd perWindow" v-for="(item,index) in dataList" :key="index">
                    <el-row>
                        <el-col :span="7" class="doctor-img">
                            <div>
                                <img :src="$store.state.imgUrl+item.picture" alt v-if="item.picture" />
                                <img :src="require('@/assets/img/doctor.png')" alt v-else />
                            </div>
                        </el-col>
                        <el-col :span="17" class="doctor-intro padding10">
                            <p>
                                <span class="weight-font">{{item.realName}}</span>&nbsp;&nbsp;
                                <span>
                                    <img :src="require('@/assets/img/love.png')" alt />
                                </span>
                                <span>{{item.consultCount}}</span>
                                <el-button type="primary" class="small-btn fr" @click="consultation(item.id)">点击咨询</el-button>
                            </p>
                            <p>
                                <span>{{item.hospital}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                                <span>{{item.title}}</span>
                            </p>
                            <p>
                                <span class="weight-font">擅长领域：</span>
                                <span>{{item.adeptDepartment}}</span>
                            </p>
                            <p>
                                <span class="weight-font">简介：</span>
                                <span
                                    class="text-justity"
                                >{{limitMaxWords(33,item.introduceMyself)}}</span>
                            </p>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <el-row>
                <el-col>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="searchObj.total"
                        :page-size="searchObj.pageSize"
                        :current-page.sync="searchObj.pageNum"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: "doctorList",
    data() {
        return {
            searchObj: {
                realName: "",
                adeptDepartment: "",
                title: "",
                hospital: "",
                total: 0, // 总数量
                pageNum: 1, // 当前第几页
                pageSize: 4 // 当前页数量条数
            },
            dataList: [] //医师列表数据
        };
    },
    methods: {
        //选页
        handleCurrentChange(v) {
            let that = this;
            that.searchObj.pageNum = v; //当前页
            that.getList();
        },
        //医师列表
        getList(a) {
            let that = this;
            if (a) {
                that.searchObj.pageNum = a;
            }
            let url = "physician/getPhysicians";
            that.$http
                .post(url, that.searchObj)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        that.dataList = res.data.list;
                        that.searchObj.total = res.data.total;
                        that.searchObj.pageSize = res.data.pageSize;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },
          //咨询医师
        consultation(id) {
            this.$router.push({
                path: "/archives",query:{ysId:id,id:this.$route.query.id,medId:this.$route.query.medId}
            });
        }
    },
    created() {
        this.getList();
        this.dataDictionary("ZC");
        this.dataDictionary("SCLY");
    }
};
</script>

<style scoped>
.search {
    display: flex;
    align-items: center;
}
.item {
    float: left;
    margin-right: 15px;
    font-size: 14px;
}
.search-inp .item .el-input,
.search-inp .item .el-select {
    margin: 5px 0;
    width: 116px;
}
.doctor-intro p {
    line-height: 25px;
}
.padding10 {
    padding: 15px 10px 0px 10px;
}
.perWindow {
    width: 48.5%;
}
.perWindow {
    margin-right: 18px;
    margin-bottom: 15px;
    display: inline-block;
}
.perWindow:nth-child(2n + 2) {
    margin-right: 0px;
}
.doctor-outer-div {
    padding: 0px 18px;
}
.doctor-img div {
    width: 114px;
    height: 156px;
    overflow: hidden;
    display: flex;
    align-items: center;
}
.doctor-img div img {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/JW/doctorList.vue